window.inputHelpers = {
    handleInputMouseDown(event) {
        event.stopPropagation();
        event.preventDefault();
        setTimeout(() => {
            event.target.select();
        }, 0);
    }
};